import React, { useCallback, useMemo } from 'react';
import { Button, IconButton, IconButton_IconSizes, IconButtonSize } from '@ydistri/ds';
import { useAppDispatch } from '../../../store';
import { AvailableModals, ModalDataMap, openModal } from '../../Modals/modalSlice';
import { MdDeleteSweep } from 'react-icons/md';
import { useCalculationEdit } from './useCalculationEdit';
import { Popover } from 'antd';

type PickingLineProductGroupsButtonProps = ModalDataMap[AvailableModals.EDIT_REDISTRIBUTION] & {
  text?: string;
  size?: IconButtonSize;
  onClick?: () => void;
};

const EditRedistributionButton: React.FC<PickingLineProductGroupsButtonProps> = ({
  text,
  size = 'small',
  onClick,
  ...data
}) => {
  const { disabledTooltipMessage, isSuperUser } = useCalculationEdit(data.calculationId);
  const dispatch = useAppDispatch();
  const removeIcon = useMemo(() => <MdDeleteSweep size={IconButton_IconSizes[size]} />, [size]);

  const onClickHandler = useCallback(() => {
    dispatch(
      openModal({
        type: AvailableModals.EDIT_REDISTRIBUTION,
        data,
      }),
    );
    onClick?.();
  }, [dispatch, data, onClick]);

  if (!isSuperUser) {
    return null;
  }

  if (text) {
    return (
      <Popover content={disabledTooltipMessage}>
        <Button onClick={onClickHandler} disabled={disabledTooltipMessage !== undefined}>
          {text}
        </Button>
      </Popover>
    );
  }

  return (
    <IconButton
      size={size}
      tooltip={disabledTooltipMessage ?? 'Remove from redistribution'}
      onClick={onClickHandler}
      icon={removeIcon}
      disabled={disabledTooltipMessage !== undefined}
    />
  );
};

export default EditRedistributionButton;
